import { Link, useLocation } from 'react-router-dom'
import { Home, PenTool, Target, Trophy, FileText } from 'lucide-react'

interface NavItem {
  label: string
  path: string
  icon: typeof Home
}

const navItems: NavItem[] = [
  { label: 'Home', path: '/dashboard', icon: Home },
  { label: 'Write', path: '/stories', icon: PenTool },
  { label: 'Studio', path: '/studio', icon: FileText },
  { label: 'Missions', path: '/dashboard', icon: Target },
  { label: 'Badges', path: '/dashboard', icon: Trophy },
]

export function BottomNav() {
  const location = useLocation()

  const isActive = (path: string, label: string) => {
    // Special case: Write is active on /stories or /stories/:id
    if (label === 'Write') {
      return location.pathname.startsWith('/stories')
    }
    // Special case: Studio is active on /studio or /studio/*
    if (label === 'Studio') {
      return location.pathname.startsWith('/studio')
    }
    // Home is only active on exact /dashboard
    if (label === 'Home') {
      return location.pathname === '/dashboard'
    }
    return location.pathname === path
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[var(--color-kids-surface-alt)] md:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const active = isActive(item.path, item.label)
          return (
            <Link
              key={item.label}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors ${
                active
                  ? 'text-[var(--color-kids-primary)]'
                  : 'text-[var(--color-kids-text-muted)]'
              }`}
            >
              <item.icon className="w-5 h-5" />
              <span className="text-[10px] font-medium">{item.label}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
